import React, {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import block from 'bem-cn-lite';
import {Text, Avatar} from '@gravity-ui/uikit';
import {Xmark, Person, ArrowRightFromSquare} from '@gravity-ui/icons';
import {Button} from '@components/shared/button';
import {AppContext} from '../../../../app/context';
import {useMediaQuery} from 'react-responsive';

import './UserCard.scss';

const b = block('user-card');

interface UserCardProps {
    onClose: () => void;
    onLogoutRequest?: () => void;
    highlightedIndex?: number;
}

const UserCard: React.FC<UserCardProps> = ({onClose, onLogoutRequest, highlightedIndex = 0}) => {
    const navigate = useNavigate();
    const {
        state: {user, clientDetails}
    } = useContext(AppContext);
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});

    function handleLogout() {
        onLogoutRequest?.();
    }

    function handleClick() {
        navigate('/profile');
        onClose();
    }

    return (
        <div className={b()} role="menu" data-keyboard-trap>
            <div className={b('header')}>
                <Text variant="subheader-3">Профиль</Text>
                <button type="button" className={b('close')} onClick={onClose} aria-label="Закрыть">
                    <Xmark />
                </button>
            </div>

            <div className={b('user')}>
                <Avatar className={b('avatar')} text={user?.displayName} theme="brand" size="l" />
                <Text variant="subheader-1">{user?.displayName}</Text>
                {/* В рамка MVP один клиент */}
                <Text className={b('title-company')} variant="body-1">
                    {clientDetails?.name || ''}
                </Text>
                {isSmallScreen && (
                    <Text variant="body-1" color="complementary" className={b('login')}>
                        Логин: {user?.login}
                    </Text>
                )}
            </div>

            <Button
                size="l"
                className={b('button-profile', {highlighted: highlightedIndex === 0})}
                onClick={handleClick}
                extraProps={{role: 'menuitem'}}
            >
                <Person /> Перейти в профиль
            </Button>

            <Button
                size="l"
                view="flat"
                className={b('button-exit', {highlighted: highlightedIndex === 1})}
                onClick={handleLogout}
                extraProps={{role: 'menuitem'}}
            >
                <ArrowRightFromSquare /> Выйти из профиля
            </Button>
        </div>
    );
};

export default UserCard;
